import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";
import {Link} from "react-router-dom";
import ListView from "../common/ListView";
import {searchProductStocks} from "./actions";
import {Button} from "antd";
import MoneyDisplay from "../common/MoneyDisplay";
import {decodeParams} from "../utils/params";

class StocksPage extends Component {
  static propTypes = {
    /* state */
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    dispensaryId: PropTypes.string.isRequired,
    search: PropTypes.object.isRequired,
    product: PropTypes.object,
    /* actions */
    searchProductStocks: PropTypes.func.isRequired,
  };

  render() {
    const {
      dispensaryId, history, searchProductStocks,
      search: {searching, pagination, filters, sorter, results, searchFilter},
      match: {params},
    } = this.props;
    const {productId} = decodeParams(params);
    const columns = [
      {
        title: 'SKU',
        dataIndex: 'sku',
        key: 'sku',
        sorter: true,
        render: (sku) => <span>{sku || '-'}</span>
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
        sorter: true,
      },
      {
        title: 'Lot Number',
        dataIndex: 'lotNumber',
        key: 'lotNumber',
        sorter: true,
        render: (lotNumber) => <span>{lotNumber || '-'}</span>
      },
      {
        title: 'Cost Price',
        dataIndex: 'averageNetCostPerUnit',
        key: 'averageNetCostPerUnit',
        sorter: true,
        render: (costPrice) => <MoneyDisplay amount={costPrice} decimals={5}/>
      },
      {
        title: 'Returns',
        dataIndex: 'returns',
        key: 'returns',
        sorter: true,
      },
      {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 180,
        render: (_, {productId, sku}) => {
          const encodedId = encodeURIComponent(productId);
          const encodedSku = encodeURIComponent(sku || '-');
          return (
            <React.Fragment>
              <Link to={`/product/adjust/${encodedId}/${encodedSku}`}>Adjust</Link>
              {' | '}
              <Link to={`/product/label/${encodedId}/${encodedSku}`}>Label</Link>
              {' | '}
              <Link to={`/product/batches/${encodedId}/${encodedSku}`}>Batches</Link>
            </React.Fragment>
          );
        }
      }
    ];
    return (
      <ListView
        title={[
          <Button key="back" icon="arrow-left" onClick={() => history.goBack()} />,
          " Stock"
        ]}
        addText="Receive"
        searchPlaceholder="Search sku and lot number"
        loading={searching}
        columns={columns}
        dataSourceProvider={(payload) => searchProductStocks({...payload, filters: {...payload.filters, productId}})}
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        dispensaryId={dispensaryId}
        rowKey="sku"
        onAdd={() => history.push(`/product/receive/${productId}/-`)}
      />
    );
  }
}

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  search: state.product.stocksSearch,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchProductStocks,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(StocksPage);



// WEBPACK FOOTER //
// ./src/Product/StocksPage.js